import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Save")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_button = _resolveComponent("el-button")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_el_select, {
      modelValue: _ctx.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.value = $event)),
      placeholder: "Select"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
          return (_openBlock(), _createBlock(_component_el_option, {
            key: item.value,
            label: item.label,
            value: item.value
          }, null, 8, ["label", "value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_table, {
      data: _ctx.defaultResourcesPermission,
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "sectionName",
          label: "Section Name"
        }),
        _createVNode(_component_el_table_column, {
          prop: "read",
          label: "Access"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_checkbox, {
              modelValue: scope.row.read,
              "onUpdate:modelValue": ($event: any) => (scope.row.read = $event)
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_el_button, {
      size: "small",
      style: {"float":"right","margin":"32px"},
      type: "primary"
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    })
  ], 64))
}